import React from "react";
import { Link } from "./../util/router";
import { Video, Sparkles, ArrowRight } from "lucide-react";

// Attention-grabbing launch bar pinned to the top of the homepage.
// Animated gradient + pulsing "LIVE" dot, with a single strong CTA to subscribe.
function VideoLaunchBanner() {
  return (
    <div className="relative w-full overflow-hidden">
      <style>{`
        @keyframes vlbShimmer {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        @keyframes vlbPulse {
          0%, 100% { opacity: .55; transform: scale(.9); }
          50% { opacity: 1; transform: scale(1.15); }
        }
      `}</style>
      <div
        className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 px-4 py-2.5 text-center"
        style={{
          background:
            "linear-gradient(90deg,#6d1399,#d6206e,#ff5b2e,#d6206e,#6d1399)",
          backgroundSize: "300% 100%",
          animation: "vlbShimmer 6s ease infinite",
        }}
      >
        <span className="inline-flex items-center gap-1.5 rounded-full bg-black/30 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white">
          <span
            className="h-2 w-2 rounded-full bg-emerald-400"
            style={{ animation: "vlbPulse 1.2s ease-in-out infinite" }}
          />
          Live
        </span>

        <span className="inline-flex items-center gap-2 text-sm font-semibold text-white sm:text-[15px]">
          <Video size={18} className="shrink-0" />
          <span>
            <span className="font-extrabold">Video Generation is HERE</span> —
            turn any image into a steamy 5-second clip.
          </span>
        </span>

        <span className="hidden text-xs font-medium text-white/85 sm:inline">
          Members only · 10 credits per clip
        </span>

        <Link
          to="/pricing"
          className="group inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 text-sm font-extrabold text-[#b3185f] shadow-md transition hover:scale-[1.03] hover:shadow-lg"
        >
          <Sparkles size={15} />
          Unlock Video — Subscribe
          <ArrowRight
            size={15}
            className="transition-transform group-hover:translate-x-0.5"
          />
        </Link>
      </div>
    </div>
  );
}

export default VideoLaunchBanner;
